import { Button, Card, Typography } from 'antd';
import { useState } from 'react';
import classNames from 'classnames';

import { BearLossCalculatorModal } from './BearLossCalculatorModal';

import { useAppSelector, useTranslate } from 'hooks';

import { language } from 'utils';

import { selectIsAdmin, selectUser } from 'selectors';

import styles from './index.module.scss';

const isEn = language === 'en';

export const BearLossCalculator = () => {
	const user = useAppSelector(selectUser);
	const isAdmin = useAppSelector(selectIsAdmin);

	const { checkText, checkAbilityLossText, readMoreText } = useTranslate([
		'checkText',
		'checkAbilityLossText',
		'readMoreText',
	]);
	const [isOpen, setIsOpen] = useState(false);
	return (
		<Card bordered={false} className={styles.root}>
			<Typography.Title level={4}>{checkAbilityLossText}</Typography.Title>

			<div className={styles.row}>
				<a
					href={
						isEn
							? 'https://crowdpear.com/wp-content/uploads/2023/09/Procedure_for_assessing_the_suitability_of_crowdfunding_transactions_and_modelling_of_the_capacity_for_loss.pdf'
							: 'https://crowdpear.com/wp-content/uploads/2023/09/Sutelktinio_finansavimo_sandoriu_tinkamumo_vertinimo_bei_gebejimo_prisiimti_nuostolius_modeliavimo_tvarka.pdf'
					}
					className={styles.link}
					target="_blank"
					rel="noreferrer"
				>
					{readMoreText}
				</a>

				<Button
					className={classNames(styles.button, { 'ant-btn-grey': isAdmin })}
					type="primary"
					onClick={() => setIsOpen(true)}
				>
					{checkText}
				</Button>
			</div>

			{isOpen && (
				<BearLossCalculatorModal
					isOpen={isOpen}
					onClose={() => setIsOpen(false)}
					value={user.riskTolerance?.value}
				/>
			)}
		</Card>
	);
};
